import React from 'react';
import img from '../img/notfound.jpg';

const Notfound = () => {
    return (
        <div>

            <img src={img} alt="" />

        </div>
    );
};

export default Notfound;